module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAGCAYAAACmekziAAAAAXNSR0IArs4c6QAAAEVJREFUOE9jZBgkgBHsjvp6Jl21RwoD5SbmX///gR1ivCqN/++Pvx8GyiEM/xk+jjoEJfRhIaI+N4mXk5XxwoBFDQPDZwBqlx3HJtKdDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/zhan1.png
// module id = r7Pj
// module chunks = 25